module.exports = `${require.publicPath}download-bg.dfa96aa2.png`;